/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MethodInfo from './MethodInfo';

/**
 * The ActionContextBooleanFunc model module.
 * @module model/ActionContextBooleanFunc
 * @version V1
 */
class ActionContextBooleanFunc {
    /**
     * Constructs a new <code>ActionContextBooleanFunc</code>.
     * @alias module:model/ActionContextBooleanFunc
     */
    constructor() { 
        
        ActionContextBooleanFunc.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ActionContextBooleanFunc</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ActionContextBooleanFunc} obj Optional instance to populate.
     * @return {module:model/ActionContextBooleanFunc} The populated <code>ActionContextBooleanFunc</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ActionContextBooleanFunc();

            if (data.hasOwnProperty('target')) {
                obj['target'] = ApiClient.convertToType(data['target'], Object);
            }
            if (data.hasOwnProperty('method')) {
                obj['method'] = MethodInfo.constructFromObject(data['method']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ActionContextBooleanFunc</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ActionContextBooleanFunc</code>.
     */
    static validateJSON(data) {
        // validate the optional field `method`
        if (data['method']) { // data not null
          MethodInfo.validateJSON(data['method']);
        }

        return true;
    }


}



/**
 * @member {Object} target
 */
ActionContextBooleanFunc.prototype['target'] = undefined;

/**
 * @member {module:model/MethodInfo} method
 */
ActionContextBooleanFunc.prototype['method'] = undefined;






export default ActionContextBooleanFunc;

